// extracted by mini-css-extract-plugin
export default {"coverLink":"KM-z","contentBox":"LM-z","zapposPromoContainer":"MM-z","zapposPromoGroupContainer":"NM-z","promos":"OM-z","bottom":"PM-z","top":"QM-z","right":"RM-z","left":"SM-z"};